import React from "react";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Button } from "@mui/material";

const StudyGuidesLink = ({ topic }) => {
  if (!topic?.referenceUrl || !topic?.referenceModeEnabled) return null;

  const urlWithTracking = new URL(topic.referenceUrl);
  urlWithTracking.searchParams.append("utm_source", "advancement-solutions");
  urlWithTracking.searchParams.append("utm_medium", "webapp");
  urlWithTracking.searchParams.append("utm_campaign", "topic-view");

  return (
    <span
      style={{
        margin: 8,
        display: "flex",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <Button
        href={urlWithTracking.toString()}
        target="_blank"
        rel="noopener noreferrer"
        endIcon={<OpenInNewIcon />}
        size="medium"
        color="primary"
        variant="contained"
      >
        View in Beta
      </Button>
    </span>
  );
};

export default StudyGuidesLink;
